import React from "react";

const AboutUs = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>Learn more about our company and team.</p>
    </div>
  );
};

export default AboutUs;
